"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const elements_ui_utils_1 = require("@hydrogen/elements.ui.utils");
const react_1 = __importDefault(require("react"));
const MetaNavWrapper = (props) => (react_1.default.createElement("div", { className: (0, elements_ui_utils_1.classNames)(props.width, props.className, 'flex flex-shrink-0 gap-4 items-center justify-end') }, props.children));
exports.default = MetaNavWrapper;
//# sourceMappingURL=MetaNavWrapper.js.map